import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'

import './ChartTooltip.scss'

const ChartTooltip = forwardRef(({ style = {}, children }, ref) => {
  return (
    <div className="chart-tooltip" ref={ref} style={style}>
      {children}
    </div>
  )
})

ChartTooltip.displayName = 'ChartTooltip'
ChartTooltip.propTypes = {
  style: PropTypes.object
}

export default ChartTooltip
